import React from 'react';
import { Separator as SeparatorShadcn } from 'shadcn/components/separator';

/**
 *
 * @param {Object} props
 * @param {boolean} props.asChild
 * @param {"horizontal" | "vertical"} props.orientation
 * @param {boolean} props.decorative
 * @param {string} props.className
 * @returns
 */
const Separator = (props) => {
  //! State

  //! Function

  //! Render
  return <SeparatorShadcn {...props} />;
};

export default Separator;
